import { prisma } from "@/lib/prisma";
import { QuestionnaireForm } from "./QuestionnaireForm";

export default async function BilanPage({ params }: { params: Promise<{ slug: string }> }) {
  const { slug } = await params;
  const pharmacy = await prisma.pharmacy.findUnique({ where: { slug } });

  if (!pharmacy || pharmacy.status !== "ACTIVE") {
    return (
      <main className="flex-1 flex items-center justify-center px-4 py-20 text-center">
        <div>
          <h1 className="text-xl font-bold text-[#07008b] mb-2">Questionnaire indisponible</h1>
          <p className="text-slate-500 max-w-sm mx-auto">
            Ce lien n&apos;est plus actif. Merci de vous rapprocher de votre pharmacie.
          </p>
        </div>
      </main>
    );
  }

  return (
    <main className="flex-1 flex flex-col">
      <header className="border-b border-slate-200 bg-white px-4 py-4 text-center">
        <p className="text-xs uppercase tracking-wide text-slate-400">Mon Bilan Prévention</p>
        <h1 className="font-bold text-[#07008b]">{pharmacy.name}</h1>
      </header>
      <QuestionnaireForm slug={slug} />
    </main>
  );
}
